import { render, staticRenderFns } from "./Books.vue?vue&type=template&id=20fab7cb&scoped=true"
import script from "./Books.vue?vue&type=script&lang=js"
export * from "./Books.vue?vue&type=script&lang=js"
import style0 from "./Books.vue?vue&type=style&index=0&id=20fab7cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fab7cb",
  null
  
)

export default component.exports